import React from 'react';
import {connect} from 'react-redux';
import {change} from 'redux-form';
import {FormattedMessage, injectIntl} from "react-intl";

import ExpandSection from "../../Generic/expandSection";
import {toggleSectionOpened} from "../AccountActions";
import {ACCOUNT_SECTIONS} from "./sectionNames";
import {getBase64ImgOnInputChange} from "../../../utilities";
import {errorBox_Show} from '../../../actions/A_Popups';

import {store} from "../../../main";

class CompanyLogo extends React.Component {

  state = {
    imageUploaded: null
  }

  handleUploadFieldChange = (event) => {
    getBase64ImgOnInputChange(event, this.onImageLoad, this.props.errorBox_Show, this.props.intl)
  };

  onImageLoad = (e) => {
    const imageUploaded = e.target.result;
    this.setState({
      imageUploaded
    })
    store.dispatch(change('newEntity', 'CompanyLogo', imageUploaded));
  };

  render() {

    const {intl} = this.props;
    const {canEditFields} = this.props.accountPageInfo;
    const companyLogoURL = this.state.imageUploaded || this.props.customerInfo.companyLogoURL;
    const sectionOpened = this.props.sectionsOpened.includes(ACCOUNT_SECTIONS.company_logo);

    return (
      <ExpandSection opened={this.props.sectionsOpened.includes(ACCOUNT_SECTIONS.company_logo)}
                     onClick={() => this.props.toggleSectionOpened(ACCOUNT_SECTIONS.company_logo)}
                     title={intl.formatMessage({id: "account.logo.sectionTitle"})}>
        <div className="acc-container">
          <div className="acc-container__row text-center">
            <div className="acc-block">
              <div id="inputContainer" className={"acc-logo" + (!canEditFields ? " acc-logo--disabled" : "")}>
                {companyLogoURL ? null : (
                  <p className="acc-logo__text"><FormattedMessage id="account.logo.uploadLogoPlaceholder"/></p>
                )}
                {sectionOpened ? <input className="acc-logo__input" id="logo" type="file"
                                        disabled={!canEditFields}
                                        onChange={this.handleUploadFieldChange}/> : null}
                <div className={"acc-logo__inner" + (companyLogoURL ? " acc-logo__inner--with-image" : "")}>
                  {companyLogoURL ? <img className={"acc-logo__inner-image"} alt="Logo" src={companyLogoURL}/> : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </ExpandSection>
    )
  }

}

const mapStateToProps = (store) => {
  return {
    sectionsOpened: store.accountState.sectionsOpened,
    accountPageInfo: store.accountState.accountPageInfo,
    customerInfo: store.newaccount.customerInfo
  };
};

const mapDispatchToProps = {
  toggleSectionOpened,
  errorBox_Show
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(CompanyLogo)
)

